import { getCookie } from '../../utils/helpers';
import { CHANGE_LANGUAGE } from './types';

let initialState = {
  siteLanguage: getCookie('site_lang') || 'en'
};
export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        siteLanguage: action.siteLanguage || 'en'
      };
    default:
      return state;
  }
};
